export default class Pagination {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(callback) {
    this.state = {
      enabled: true,
      currentPage: 1,
      paginateWait: false,
      infinite: $('.js-pagination-infinite')[0],
      paginationType: $('.js-pagination-type').val() || '',
      paginationSize: Number($('.js-pagination-page-size').val()) || 20,
      totalCount: Number($('.js-pagination-total-count').val()) || 0,
      totalPages: Number($('.js-pagination-pages').val()) || 1,
      callback: callback || function(){},
      listeners: [],
      textListeners: []
    };

    this.updatePagination();
    this.setupPaginationTextList();
    this.setupEventListenersOnLoad();
  }

  //===========================================================================
  // State getter
  //===========================================================================

  get(key) {
    return this.state[key];
  }

  //===========================================================================
  // State setter
  //===========================================================================

  set(key, value) {
    this.state[key] = value;
  }

  //===========================================================================
  // Switches pages
  //===========================================================================

  paginate(e) {
    if (this.state.enabled && !this.state.paginateWait) {
      const $target = $(e.currentTarget);

      if ($target.is('a')) {
        e.preventDefault();
      }

      if ($target.hasClass('prev')) {
        this.state.currentPage -= 1;
      } else {
        this.state.currentPage += 1;
      }

      this.paginateWait();
      this.state.callback();
    }
  }

  //===========================================================================
  // Sets a variable to limit 1 page switch per second
  //===========================================================================

  paginateWait() {
    this.state.paginateWait = true;

    setTimeout(() => {
      this.state.paginateWait = false;
    }, 1000);
  }

  //===========================================================================
  // Infinite Scroll Pagination
  //===========================================================================

  infiniteScroll(e) {
    if (this.state.enabled && this.state.infinite) {
      const bounds = this.state.infinite.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const inView = (bounds.top + 100) < windowHeight;

      if (inView && this.state.currentPage < this.state.totalPages) {
        this.paginate(e);
      }
    }
  }

  //===========================================================================
  // Updates count and buttons
  //===========================================================================

  updatePagination() {
    this.updatePaginationCount();
    this.updatePaginationButtons();
    this.setupPaginationTextList();
    this.resetEventListeners();
  }

  //===========================================================================
  // Updates elements based on number of displayed items
  //===========================================================================

  updatePaginationCount() {
    const $toHide = $('.js-empty-pagination-hide');
    const $toShow = $('.js-empty-pagination-show');
    const $label = $('.js-pagination-count-label');
    const count = this.state.totalCount || 0;
    const paginationSize = this.state.paginationSize;

    $('.js-pagination-total-count').val(count);
    $label.text(`${ count } ${ count == 1 ? "item" : "items" }`);
    this.state.totalPages = Math.ceil(count / paginationSize) || 1;

    if (count == 0) {
      $toHide.addClass('hidden');
      $toShow.removeClass('hidden');
    } else {
      $toHide.removeClass('hidden');
      $toShow.addClass('hidden');
    }
  }

  //===========================================================================
  // Updates the pagination buttons for the current page
  //===========================================================================

  updatePaginationButtons() {
    const $pagination = $('.js-pagination-wrapper');
    const $btnPrev    = $('.js-pagination.prev');
    const $btnNext    = $('.js-pagination.next');
    const $btnMore    = $('.js-pagination.more');
    const $pgCurrent  = $('.js-pagination-current-page');
    const $pgTotal    = $('.js-pagination-total-pages');

    $pgCurrent.text(this.state.currentPage);
    $pgTotal.text(this.state.totalPages);

    if (this.state.totalPages <= 1) {
      $pagination.addClass('hidden');
    } else {
      $pagination.removeClass('hidden');
    }

    if (this.state.currentPage >= this.state.totalPages) {
      $btnPrev.prop('disabled', false);
      $btnNext.prop('disabled', true);
      $btnMore.addClass('hidden');
    } else if (this.state.currentPage <= 1) {
      $btnPrev.prop('disabled', true);
      $btnNext.prop('disabled', false);
      $btnMore.removeClass('hidden');
    } else {
      $btnPrev.prop('disabled', false);
      $btnNext.prop('disabled', false);
      $btnMore.removeClass('hidden');
    }
  }

  //===========================================================================
  // Checks if an item belongs on the current pagination page
  //===========================================================================

  validateItemForPagination(pageNumber) {
    switch(this.state.paginationType) {
      case 'pages':
        return pageNumber === this.state.currentPage;
      case 'show_more':
        return pageNumber <= this.state.currentPage;
      case 'infinite':
        return pageNumber <= this.state.currentPage
      default:
        return true;
    }
  }

  //===========================================================================
  // Updates simple text list pagination
  //===========================================================================

  setupPaginationTextList() {
    const $lists = $('.js-text-list-wrapper');

    $lists.each((i, list) => {
      const $list = $(list);
      const $items = $list.find('.js-text-list-item.hidden');
      const $pagination = $list.find('.js-pagination-text-wrapper');
      const count = $list.find('.js-pagination-text-size').val() || 20;

      if ($items.length) {
        $pagination.removeClass('hidden');
      } else {
        $pagination.addClass('hidden');
      }
    });
  }

  //===========================================================================
  // Paginates a text list
  //===========================================================================

  paginateTextList(e) {
    const $target = $(e.currentTarget);
    const $pageWrapper = $target.closest('.js-pagination-text-wrapper');
    const $wrapper = $target.closest('.js-text-list-wrapper');
    const $items = $wrapper.find('.js-text-list-item.hidden');
    const itemsNumber = $wrapper.find('.js-pagination-text-size').val() || 20;
    let paginateMore = false;
    let count = 0;

    e.preventDefault();

    $items.each((i, item) => {
      if (count > itemsNumber) {
        paginateMore = true;
      } else {
        $(item).removeClass('hidden');
        count += 1;
      }
    });

    if (count < $items.length) {
      $pageWrapper.removeClass('hidden');
    } else {
      $pageWrapper.addClass('hidden');
    }
  }

  //===========================================================================
  // Removes pagination
  //===========================================================================

  resetEventListeners() {
    this.remove();
    this.setupEventListeners();
  }

  //===========================================================================
  // Removes pagination
  //===========================================================================

  remove() {
    this.state.enabled = false;

    this.state.listeners.forEach(($pagination) => {
      $pagination.off('click', this.paginate.bind(this));
    });

    this.state.textListeners.forEach(($textPagination) => {
      $textPagination.off('click', this.paginateTextList.bind(this));
    });
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    const $pagination = $('.js-pagination');
    const $textPagination = $('.js-pagination-text');

    this.state.enabled = true;
    this.state.listeners.push($pagination);
    this.state.textListeners.push($textPagination);

    $pagination.on('click', this.paginate.bind(this));
    $textPagination.on('click', this.paginateTextList.bind(this));
  }

  //===========================================================================
  // Sets up the event listeners for page load
  //===========================================================================

  setupEventListenersOnLoad() {
    this.setupEventListeners();

    if (this.state.paginationType === 'infinite') {
      $(window).on('resize', this.infiniteScroll.bind(this));
      $(window).on('scroll', this.infiniteScroll.bind(this));
    }
  }
}
